{
  "DatePicker": {
    "toggleIncludeHoursRich": "<p>Specify the exact start / end time of this date range</p>Press <kbd>,</kbd> to toggle",
    "toggleIncludeHours": "Set specific start / end time",
    "toggleIncludeHoursHint": "Press",
    "pressEnterToApply": "Press <kbd><enter/></kbd> to apply",
    "presetsLabel": "Date Picker Presets",
    "presetsHeader": "Presets",
    "range": {
      "lastWeek": "Last week",
      "currentWeek": "Current week",
      "lastMonth": "Last month",
      "currentMonth": "Current month",
      "last3Months": "Last quarter",
      "current3Months": "Current quarter",
      "lastYear": "Last year",
      "currentYear": "Current year",
      "allTime": "All time"
    }
  },
  "Select": {
    "clear": "Remove selected",
    "emptyPlaceholder": "Select"
  },
  "TernaryToggle": {
    "yes": "Yes",
    "no": "No",
    "notSet": "Not set",
    "emptyValue": "n/a"
  },
  "Pagination": {
    "page": "Page {{current}} / {{total}}",
    "pageFraction": "{{current}} / {{total}}",
    "navigation": "Pagination",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "jumpInput": "Page number",
    "jumpPlaceholder": "1 - {{total}}",
    "jumpAction": "Jump To"
  }
}
